<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const tableWrapper = ref(null);
const showLeftShadow = ref(false);
const showRightShadow = ref(false);

const checkScroll = () => {
  if (!tableWrapper.value) return;

  const { scrollLeft, scrollWidth, clientWidth } = tableWrapper.value;

  // Afficher l'ombre gauche si on a scrollé vers la droite
  showLeftShadow.value = scrollLeft > 0;

  // Afficher l'ombre droite si on peut encore scroller vers la droite
  showRightShadow.value = scrollLeft < scrollWidth - clientWidth - 1;
};

onMounted(() => {
  if (tableWrapper.value) {
    tableWrapper.value.addEventListener('scroll', checkScroll);
    // Vérifier au montage
    checkScroll();

    // Vérifier aussi au resize
    window.addEventListener('resize', checkScroll);
  }
});

onUnmounted(() => {
  if (tableWrapper.value) {
    tableWrapper.value.removeEventListener('scroll', checkScroll);
  }
  window.removeEventListener('resize', checkScroll);
});
</script>

<template>
  <div class="relative">
    <!-- Ombre gauche pour indiquer le scroll -->
    <div
      v-if="showLeftShadow"
      class="absolute left-0 top-0 bottom-0 w-8 pointer-events-none z-10 bg-gradient-to-r from-n-solid-1/80 to-transparent dark:from-n-solid-1/80"
    />

    <!-- Wrapper avec scroll horizontal -->
    <div
      ref="tableWrapper"
      class="overflow-x-auto scrollbar-thin scrollbar-thumb-n-slate-6 scrollbar-track-n-slate-3 hover:scrollbar-thumb-n-slate-7"
    >
      <slot />
    </div>

    <!-- Ombre droite pour indiquer le scroll -->
    <div
      v-if="showRightShadow"
      class="absolute right-0 top-0 bottom-0 w-8 pointer-events-none z-10 bg-gradient-to-l from-n-solid-1/80 to-transparent dark:from-n-solid-1/80"
    />
  </div>
</template>

<style scoped>
/* Scrollbar personnalisée pour navigateurs webkit */
:deep(.overflow-x-auto::-webkit-scrollbar) {
  height: 8px;
}

:deep(.overflow-x-auto::-webkit-scrollbar-track) {
  background: var(--n-slate-3);
  border-radius: 4px;
}

:deep(.overflow-x-auto::-webkit-scrollbar-thumb) {
  background: var(--n-slate-6);
  border-radius: 4px;
}

:deep(.overflow-x-auto::-webkit-scrollbar-thumb:hover) {
  background: var(--n-slate-7);
}
</style>
